<template>
  <div class="postavitev-info">
    <div class="info-okvir">
      <div class="postavitev-info-icone">
        <i class="fa fa-info-circle"></i>
      </div>
      <div class="postavitev-info-tekst">
        <p class="modra-barva-info">
          Preusmeritve lahko nastavite tudi ročno preko terminala (mobilnega ali stacionarnega telefona)
          z uporabo kratkih kod ali ukaznih nizov, ki jih boste našli na spletni strani:
          <a :href="povezavaUporabaTelFunkcij">
            {{povezavaUporabaTelFunkcij}}</a>.
        </p>
      </div>
    </div>
  </div>
</template>
<script>
import {povezave} from '../../../../../../assets/js/Povezave/povezave'

export default {
  name: 'InfoOknoPreusmeritve',
  data () {
    return {
      povezavaUporabaTelFunkcij: povezave.BASE_URL_NAVODILA_PREUSMERITVE
    }
  }
}
</script>
<style scoped src="../../../../../../../static/css/Nastavitve/Telefonija/InfoOknoPreusmeritve.css"/>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Nastavitve/NastavitveTelefonije/NastavitveMobilnaTelefonija/InfoOknoPreusmeritve.vue